/* eslint-disable  */
import React, { useState } from "react";
import {
  Alert,
  Button,
  Checkbox,
  Form,
  Input,
  Modal,
  Typography,
  message,
} from "antd";
import { saveProjectBankAccount } from "../../components/utils/bankAccount";

const { Text } = Typography;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const validateMessages = {
  required: "${label} is required!",
};

export default function BankAccountModal({ projectId, onSubmitted }) {
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();

  const handleOpen = () => {
    form.resetFields();
    setOpen(true);
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      const saved = await saveProjectBankAccount(projectId, values);
      message.success("Bank account details saved");
      onSubmitted?.(saved);
      setOpen(false);
    } catch (e) {
      if (e?.errorFields) return;
      message.error(
        e?.message || "Could not save bank account details. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Button type="primary" onClick={handleOpen}>
        Add bank details
      </Button>
      <Modal
        title="Bank account details"
        visible={open}
        onCancel={() => {
          if (!submitting) setOpen(false);
        }}
        wrapClassName="vc-lead-modal-wrap"
        destroyOnClose
        width={560}
        footer={[
          <Button
            key="cancel"
            onClick={() => setOpen(false)}
            disabled={submitting}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={submitting}
            onClick={handleSubmit}
          >
            Submit bank details
          </Button>,
        ]}
      >
        <Alert
          type="warning"
          showIcon
          message="You can only submit these details once"
          description="Double-check your account name, number, IFSC, and PAN before submitting. These details cannot be edited after submission — contact support@shortedfilms.com if something is wrong."
          style={{ marginBottom: 24 }}
        />
        <Form
          form={form}
          {...layout}
          validateMessages={validateMessages}
          name="bank-account"
        >
          <Form.Item
            name="ac_name"
            label="A/C Name"
            rules={[{ required: true }]}
          >
            <Input placeholder="Account holder name" autoComplete="off" />
          </Form.Item>
          <Form.Item
            name="ac_number"
            label="A/C Number"
            rules={[{ required: true }]}
          >
            <Input placeholder="Bank account number" autoComplete="off" />
          </Form.Item>
          <Form.Item name="ac_bank" label="Bank" rules={[{ required: true }]}>
            <Input placeholder="Bank name" autoComplete="off" />
          </Form.Item>
          <Form.Item name="ifsc" label="IFSC Code" rules={[{ required: true }]}>
            <Input placeholder="e.g. HDFC0001234" autoComplete="off" />
          </Form.Item>
          <Form.Item name="pan" label="PAN" rules={[{ required: true }]}>
            <Input placeholder="PAN card number" autoComplete="off" />
          </Form.Item>
          <Form.Item
            name="confirmed"
            valuePropName="checked"
            wrapperCol={{ offset: 8, span: 16 }}
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error(
                          "Confirm that you understand this is a one-time submission"
                        )
                      ),
              },
            ]}
          >
            <Checkbox>
              <Text>
                I confirm these details are correct and understand they can only
                be submitted once.
              </Text>
            </Checkbox>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
